module.exports = __webpack_public_path__ + "static/we-do-f406a58403847e70cb5d27252b600a03.gif";